/* plugins/myPlugin.js 自定义插件 */

import { post } from "./index.js";

// 自定义插件
export default {
  install: (Vue) => {
    // Vue 混入成员
    Vue.mixin({
      methods: {
        /**
         *
         * @param {*} shop_role
         */
        $getMerchantRoleList(shop_role = "") {
          const typeList = JSON.parse(JSON.stringify(this.typeList));

          if (shop_role === "" || typeList.length === 0) {
            return false;
          }

          const shopRoleList = this.$stringToArray(shop_role);

          let newTypeList = [];

          this.typeList.forEach((value, index) => {
            if (shopRoleList.includes(value.id)) {
              newTypeList.push(value);
            }
          });

          this.shopTypeList = newTypeList;
        },
        /**
         * 商户列表
         * @param {Number} type
         */
        async $getMerchantList(type = 1) {
          const { code, data } = await this.$post("manage/merch/getAllList", {
            type,
          });

          if (code === 200) {
            this.merchantList = data;
          }
        },
        /**
         * 获取类型列表
         */
        async $getTypeList() {
          const { code, data } = await this.$post("merchant/shop/getShopType");

          if (code === 200) {
            this.typeList = data;
          }
        },
        /**
         * 省市区列表
         */
        async $getCityList(name = "tableData") {
          const { code, data } = await this.$post(
            "manage/common/getProvinceCityArea"
          );

          if (code === 200) {
            this[name] = data;
          }
        },
        /**
         * 获取分类列表
         */
        async $getProductTypeList() {
          const { code, data, total_number } = await post(
            "manage/product/getProductTypeList",
            this.pageData
          );

          if (code === 200) {
            this.tableData = data;

            this.pageData.total = total_number;
          }
        },
      },
    });
  },
};
